import { FC, useEffect } from "react";
import { Controller } from "react-hook-form";
import { useI18n } from "../../hooks/useTranslations";
import { Supplier } from "../../http/supplier/types";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import Input from "../ui/Input";

export interface SupplierFormBody {
  code: string;
  name: string;
}

type SupplierFormProps = {
  supplier?: Supplier;
  onSubmit: (data: SupplierFormBody) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const SupplierForm: FC<SupplierFormProps> = ({ supplier, onSubmit, isDisabled, isLoading }) => {
  const i18n = useI18n();

  const defaultValues = {
    name: supplier?.name ?? "",
    code: supplier?.code ?? "",
  };

  return (
    <Form<SupplierFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled}
      onSubmit={() => onSubmit}
    >
      {({ control, reset }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [supplier]);

        return (
          <>
            <Controller
              name="code"
              control={control}
              rules={{ required: i18n.t.common.fieldCannotBeEmpty }}
              render={({ field, fieldState }) => (
                <FormField label={i18n.t.common.code} error={fieldState.error}>
                  {({ labelId, isInvalid }) => (
                    <Input
                      id={labelId}
                      {...field}
                      isInvalid={isInvalid}
                      disabled={isDisabled || isLoading || !!supplier}
                    />
                  )}
                </FormField>
              )}
            />

            <Controller
              name="name"
              control={control}
              rules={{ required: i18n.t.common.fieldCannotBeEmpty }}
              render={({ field, fieldState }) => (
                <FormField label={i18n.t.common.name} error={fieldState.error}>
                  {({ labelId, isInvalid }) => (
                    <Input id={labelId} {...field} isInvalid={isInvalid} disabled={isDisabled || isLoading} />
                  )}
                </FormField>
              )}
            />
          </>
        );
      }}
    </Form>
  );
};

export default SupplierForm;
